// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 957 ? "views-app" : chunkId) + "." + {"660":"181f14e5","957":"0516e12f"}[chunkId] + ".chunk.css";
};